import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("acp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Separate instance for customer (storefront) auth — sends the customer token.
export const customerApi = axios.create({ baseURL: API });
customerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("acp_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const money = (v) =>
  `$${Number(v || 0).toLocaleString("en-NZ", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
